import type { PublicApiKey } from '#packages/apilib';
import type { createClipboardApi } from './clipboardWrapper';

export const ClipboardApiKey: PublicApiKey<typeof createClipboardApi> = {
  name: 'ClipboardApi',
  public: true,
};
